<template>
  <v-data-table
    :items="filteredProductToOrder"
    :headers="headers"
    :loading="loading"
    dense
    sort-by="name"
    hide-default-footer
    :mobile-breakpoint="0"
    :items-per-page="productToOrder.length + 1"
  ></v-data-table>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
export default {
  name: "InventoryOrderGrid",
  props: {
    products: {
      type: Array,
      required: true
    },
    template: {
      required: true
    },
    hideZero: {
      type: Boolean
    },
    tags: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  computed: {
    ...mapGetters(["getStoreId"]),
    filteredProductToOrder() {
      let products = this.productToOrder;
      if (this.hideZero) {
        products = products.filter(x => x.quantity_to_order > 0);
      }
      if (this.tags.length > 0) {
        products = products.filter(x =>
          this.tags.every(t => x.data.tags.includes(t))
        );
      }
      return products;
    }
  },
  data() {
    return {
      headers: [
        { value: "number", text: "Numéro de commande" },
        { value: "name", text: "Nom" },
        { value: "min_quantity", text: "Quantité requise" },
        { value: "current_quantity", text: "Quantité actuelle" },
        { value: "quantity_to_order", text: "Quantité à commander" },
        { value: "unit", text: "Unité" }
      ],
      productOrderQuantities: [],
      productToOrder: [],
      loading: false
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        this.productToOrder = [];
        const res = await api.getRecipeProductOrderQuantities(
          null,
          this.template
        );
        this.productOrderQuantities = res.filter(
          x => x.store === this.getStoreId
        );
        this.productOrderQuantities.forEach(x => {
          const relatedProduct = this.products.find(
            p => p.fk_product === x.fk_product
          );
          if (relatedProduct) {
            const data = {
              tags: relatedProduct.tags,
              number: relatedProduct.order_number,
              name: relatedProduct.nom,
              min_quantity: x.quantity,
              current_quantity: relatedProduct.quantity,
              quantity_to_order:
                x.quantity - relatedProduct.quantity > 0
                  ? x.quantity - relatedProduct.quantity
                  : 0,
              unit: relatedProduct.unit
            };

            this.productToOrder.push(data);
          }
        });
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    template(v) {
      if (v !== null) {
        this.getData();
      } else {
        this.productToOrder = [];
      }
    }
  }
};
</script>

<style></style>
